<template>
  <v-card :class="(noAction ? 'pb-5 ' : '') + 'mx-auto mb-2'" max-width="500">
    <v-img contain v-if="media" class="white--text align-end" max-height="500px" :src="background"
      gradient="0deg, rgba(0,0,0,0.5) 0%, rgba(128,128,128,0.5) 26%, rgba(255,255,255,0) 100%">
      <v-card-subtitle class="white--text">{{ createdAt }}</v-card-subtitle>
    </v-img>

    <v-card-subtitle class="d-flex" v-if="!media || type === postsConstants.ALERT_TYPE">
      <div class="text-left" v-if="!media">{{ createdAt }}</div>
      <v-spacer />
      <div class="text-right" v-if="type === postsConstants.ALERT_TYPE">
        <v-icon small class="mr-1 pt-0 pb-1" color="error">mdi-alert-outline</v-icon>
        <span class="font-weight-medium subtitle-2">Atualização da COVID-19</span>
      </div>
    </v-card-subtitle>

    <v-card-title v-if="title">{{ title }}</v-card-title>

    <v-card-subtitle v-if="eventSchedule">{{ eventSchedule }}</v-card-subtitle>

    <v-card-text class="py-0" v-if="offerRedeemOnlineUrl">
      <v-btn outlined small color="primary" @click="openLink(offerRedeemOnlineUrl)">Resgatar on-line</v-btn>
    </v-card-text>

    <v-card-text v-if="offerCouponCode || eventScheduleCode">
      <v-card outlined class="dashed-border" color="grey lighten-4">
        <v-card-subtitle>
          <p v-if="offerCouponCode" style="text-align: center" class="my-0 py-0 text--black caption">
            Mostre este código na loja
          </p>
          <p v-if="offerCouponCode" style="text-align: center; color: black" class="my-3 py-0 text-h5 font-weight-bold">
            {{ offerCouponCode }}
          </p>
          <p v-if="eventScheduleCode" style="text-align: center" class="my-0 py-0 text--black caption">
            Validade: {{ eventScheduleCode }}
          </p>
        </v-card-subtitle>
      </v-card>
    </v-card-text>

    <v-card-text class="py-0" v-if="offerTermsAndConditions">
      <v-btn x-small text color="primary" @click="openTerms = !openTerms">
        Termos e Condições
        <v-icon>{{ openTerms ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
      <v-expand-transition>
        <div v-show="openTerms" class="pl-2">
          {{ offerTermsAndConditions }}
        </div>
      </v-expand-transition>
    </v-card-text>

    <v-card-text class="text--primary" v-if="summary">{{ summary }}</v-card-text>

    <v-card-text class="py-0" v-if="actionButtonLink && actionButtonType">
      <v-btn outlined color="primary" @click="openLink(actionButtonLink)">
        {{ getButtonName(actionButtonType) }}
      </v-btn>
    </v-card-text>

    <v-card-actions class="mt-3">
      <location-post-modal v-if="!noAction" :location-name="locationName" :location-phone="locationPhone"
        :on-updated="onPostUpdated" :on-bulk-updated="onPostBulkUpdated" :id="id" :title="title" :summary="summary"
        :prop-type="type" :action-button-link="actionButtonLink" :action-button-type="actionButtonType"
        :created-at="createdAt" :alert-type="alertType" :event-schedule="eventSchedule"
        :event-schedule-code="eventScheduleCode" :offer-coupon-code="offerCouponCode"
        :offer-redeem-online-url="offerRedeemOnlineUrl" :offer-terms-and-conditions="offerTermsAndConditions"
        :open-date="openDate" :open-time="openTime" :close-date="closeDate" :close-time="closeTime" :image="media"
        :media-format="mediaFormat" :bulk-update="bulkUpdate" :bulk-params="bulkParams"
      />

      <confirm-modal v-if="!noAction" :loading="loadingDelete" text action-color="info" action-text="Excluir" small
        :action="deletePost" title="Excluir postagem"
        description="Não será possível recuperar essa postagem após a exclusão. Todas as informações associadas a ela também serão excluídas."
      />

      <v-spacer></v-spacer>

      <span class="font-weight-regular text-caption">Id: {{ id }}</span>
    </v-card-actions>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Ok</v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import * as postsConstants from '@/constants/posts'
import ConfirmModal from '@/components/ConfirmModal'
import LocationPostModal from '@/views/Locations/Modals/LocationPostModal'
import { handleResponseError } from '@/api/handleError'
import { TYPE_DELETE_LOCAL_POST } from '@/constants/tasks'

export default {
  name: 'LocationPost',
  props: {
    id: Number,
    bulkUpdate: Boolean,
    bulkParams: Object,
    title: String,
    background: String,
    media: String,
    mediaFormat: String,
    summary: String,
    type: String,
    actionButtonType: String,
    actionButtonLink: String,
    createdAt: String,
    alertType: String,
    eventSchedule: String,
    eventScheduleCode: String,
    offerRedeemOnlineUrl: String,
    offerCouponCode: String,
    offerTermsAndConditions: String,
    locationName: String,
    locationPhone: String,
    onUpdated: Function,
    onBulkUpdated: Function,
    onBulkDeleted: Function,
    noAction: Boolean,
    openDate: String,
    openTime: String,
    closeDate: String,
    closeTime: String,
  },
  components: {
    ConfirmModal,
    LocationPostModal
  },
  computed: {
    postsConstants: function () {
      return postsConstants
    }
  },
  data: () => ({
    openTerms: false,
    loadingDelete: false,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
  }),
  methods: {
    onPostUpdated: function () {
      if (this.onUpdated) this.onUpdated()
    },
    onPostBulkUpdated: function () {
      if (this.onBulkUpdated) this.onBulkUpdated()
    },
    openLink: function (url) {
      window.open(url)
    },
    getButtonName: function (type) {
      switch (type) {
        case postsConstants.ACTION_TYPE_BOOK:
          return 'Reservar'
        case postsConstants.ACTION_TYPE_ORDER:
          return 'Fazer o pedido'
        case postsConstants.ACTION_TYPE_SHOP:
          return 'Comprar'
        case postsConstants.ACTION_TYPE_LEARN_MORE:
          return 'Saiba mais'
        case postsConstants.ACTION_TYPE_SIGN_UP:
          return 'Inscreva-se'
        case postsConstants.ACTION_TYPE_CALL:
          return 'Ligar agora'
        default:
          return ''
      }
    },
    deletePost: async function () {
      this.loadingDelete = true
      if (this.bulkUpdate) {
        const payload = {
          schedule_type: TYPE_DELETE_LOCAL_POST,
          params: {
            allSelected: this.allSelected ? 1 : 0,
            account: this.bulkParams.account,
            ids: this.bulkParams.ids,
            total: this.bulkParams.total,
            filters: this.bulkParams.filters,
            local_post_id: this.id
          }
        }

        await this.$store.dispatch('posts/destroyBulk', JSON.stringify(payload)).then(() => {
          if (this.onBulkDeleted) this.onBulkDeleted()
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao excluir a postagem.')
          this.showNotification(message, 'red darken-2')
          this.loadingDelete = false
        })
      } else {
        await this.$store.dispatch('posts/destroy', this.id).then(() => {
          if (this.onUpdated) this.onUpdated()
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao excluir a postagem.')
          this.showNotification(message, 'red darken-2')
          this.loadingDelete = false
        })
      }

      this.loadingDelete = false
    },
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
  }
}
</script>

<style scoped>
.dashed-border {
  border: none;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23E0E0E0FF' stroke-width='4' stroke-dasharray='3%2c 9' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 12px;
}

.iframe-card {
  position: relative;
  overflow: hidden;
  width: 100%;
}
</style>
